import * as SelectPrimitive from '@radix-ui/react-select';
import { ForwardedRef, useContext } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../../core';
import { Icon } from '../../icon';
import { CellulaInputSelectContext } from './_input_select.context';
import { theme } from './input_select.theme';

const elements = {
	item: styled(SelectPrimitive.Item)`
		all: unset;
		font: ${coreTokens.text.body.regular};
		line-height: 1;
		color: ${theme.getValue('itemColor')};
		border-radius: ${theme.getValue('itemBorderRadius')};
		display: flex;
		align-items: center;
		position: relative;
		user-select: none;
		transition: all 150ms ease-out;
		box-sizing: border-box;
		height: ${theme.getValue('itemHeightMobile')};
		padding: ${theme.getValue('itemPaddingMobile')};

		${coreTokens.breakpointQuery.medium} {
			height: ${theme.getValue('itemHeight')};
			padding: ${theme.getValue('itemPadding')};
		}

		&[data-disabled] {
			color: ${theme.getValue('itemDisabledColor')};
			pointer-events: none;
		}

		&[data-state='checked'] {
			font: ${theme.getValue('itemCheckedFont')};
			background: ${theme.getValue('itemCheckedBackground')};
		}

		@media (hover: hover) {
			&[data-highlighted] {
				background-color: ${theme.getValue('itemHighlightBackground')};
			}
		}

		&:active {
			background: ${theme.getValue('itemCheckedBackground')};
		}
	`,
	indicator: styled(SelectPrimitive.ItemIndicator)`
		position: absolute;
		right: ${theme.getValue('itemIndicatorSpacingMobile')};
		color: ${theme.getValue('itemIndicatorColor')};
		width: 25px;
		display: inline-flex;
		align-items: center;
		justify-content: center;

		${coreTokens.breakpointQuery.medium} {
			right: ${theme.getValue('itemIndicatorSpacing')};
		}
	`,
};

export interface InputSelectItemProps extends SelectPrimitive.SelectItemProps {}

export function CellulaInputSelectItem({ disabled, ...rest }: InputSelectItemProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	// biome-ignore lint/correctness/useHookAtTopLevel: suppressed due to migration - should be fixed
	const { readOnly: readonly } = useContext(CellulaInputSelectContext);

	return (
		<elements.item disabled={readonly || disabled} {...rest} ref={ref}>
			<SelectPrimitive.ItemText>{rest.children}</SelectPrimitive.ItemText>
			<elements.indicator>
				<Icon type='check' />
			</elements.indicator>
		</elements.item>
	);
}
